/**
 *    @tableOfContent
 *      1. Dependencies
 *      2. Class
 *      3. Export class
 *
 */

/**
 *     @section 1. Dependencies
 */
// nothing yet

/**
 *     @section 2. Class
 */
class Cards {
    constructor() {
        const cardsItemsEl = document.querySelector('.cards__items')

        if (cardsItemsEl) {
            this.sortElementsRandomInDom(cardsItemsEl, 'li')
        }
    }

    private sortElementsRandomInDom(container: Element | null, childSelector: string): void {
        const elements = container?.querySelectorAll(childSelector)
        if (!elements) return

        const elementsArray = Array.from(elements)
        for (let i = elementsArray.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1))
            ;[elementsArray[i], elementsArray[j]] = [elementsArray[j], elementsArray[i]]
        }
        elementsArray.forEach((element) => {
            container?.appendChild(element)
        })

        container?.classList.add('sorted')
    }
}

/**
 *     @section 3. Export class
 */

export default new Cards()

// end of cards.ts file
